'use strict';
import 'rxjs/add/operator/map';
import {IonKeyboardAttach} from '../../../_libs/reactionic/src/components/ionKeyboardAttach';
import fuse from '../../../_libs/redux-fusion';
import {actions as authModalActions} from '../../redux/authModal';
import {LoginView} from './LoginView';

const StreamedComponent = (state$, dispatch) => (props$) => {
  const onShowLogin = payload => dispatch(authModalActions.showModal(payload));

  return props$
    .map(props => ({
      ...props,
      onShowLogin,
    }));
};

export const LoginContainer = fuse(StreamedComponent)(IonKeyboardAttach(LoginView));



// WEBPACK FOOTER //
// ./src/js/auth/components/Login/LoginContainer.js